import Iconify from "../iconify/iconify";

export function MethodPill({
  method,
  bank,
}: {
  method: "CASH" | "BANK" | "BAKONG";
  bank?: string;
}) {
  if (method === "CASH") {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100 px-2 py-0.5 text-[11px]">
        <Iconify icon="mdi:cash" className="h-3.5 w-3.5" />
        Cash
      </span>
    );
  }

  if (method === "BAKONG") {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-red-50 text-red-700 border border-red-100 px-2 py-0.5 text-[11px]">
        <Iconify icon="mdi:bank" className="h-3.5 w-3.5" />
        BAKONG
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 text-blue-700 border border-blue-100 px-2 py-0.5 text-[11px]">
      <Iconify icon="mdi:bank" className="h-3.5 w-3.5" />
      {bank || "Bank"}
    </span>
  );
}
